import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';

import { TeamMember } from '../../API';
import { useTeamManagement } from './useTeamManagement';

interface RoleChangeConfirmationDialogProps {
    open: boolean;
    member: TeamMember | null;
    isSelfDemotion?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const RoleChangeConfirmationDialog = ({
    open,
    member,
    isSelfDemotion = false,
    onClose,
    onConfirm,
}: RoleChangeConfirmationDialogProps) => {
    const { getUserById } = useTeamManagement();
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                {isSelfDemotion ? 'Warning: Self-Demotion' : 'Confirm Role Change'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {isSelfDemotion ? (
                        <>
                            You are about to demote yourself from Owner to Member. This will remove your administrative privileges.
                            You will no longer be able to:
                            <ul>
                                <li>View this page</li>
                                <li>Change team member roles</li>
                                <li>Remove team members</li>
                                <li>Send team invitations</li>
                            </ul>
                            Are you sure you want to proceed?
                        </>
                    ) : (
                        <>
                            Are you sure you want to change {getUserById(member?.userId ?? '')?.name ?? 'this user'}'s role to Owner?
                            This will give them full administrative access to the team.
                        </>
                    )}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color="error"
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}; 